var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConsentMgmtNoPreferenceCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 71.682a39.4 39.4 0 1155.72-55.72 39.4 39.4 0 01-55.72 55.72z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.803 53.34a26.717 26.717 0 1149.365-20.447A26.717 26.717 0 0116.803 53.34z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.169 43.117a27.316 27.316 0 1054.631 0 27.316 27.316 0 00-54.631 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.326 15.982c.573-5.573 1.406-8.96 2.4-8.982 2.167-.046 4.267 16.087 4.689 36.034.422 19.947-.993 36.154-3.161 36.2-.99.021-1.964-3.329-2.772-8.874",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.438 21.697c4.346-3.537 7.331-5.344 8.045-4.66 1.565 1.5-8.358 14.393-22.164 28.8-13.806 14.409-26.268 24.859-27.832 23.359-.714-.685.965-3.744 4.315-8.236",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 46.275c-5.573-.573-8.961-1.406-8.982-2.4-.046-2.165 16.083-4.265 36.034-4.684 19.95-.42 36.154.993 36.2 3.16.02.99-3.33 1.965-8.873 2.773",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.066 26.165c-3.537-4.347-5.345-7.332-4.66-8.046 1.5-1.565 14.393 8.358 28.8 22.164C58.613 54.09 69.064 66.55 67.564 68.111c-.685.714-3.743-.965-8.236-4.315",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.586 19.152a2.9 2.9 0 114.102-4.101 2.9 2.9 0 01-4.102 4.101z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.137 17.102a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.423 20.234a2.9 2.9 0 114.102-4.101 2.9 2.9 0 01-4.102 4.101z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.974 18.184a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.902 10.818a5.4 5.4 0 117.637-7.636 5.4 5.4 0 01-7.637 7.636z",
    fill: "#fff",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.72 7a6 6 0 1012 0 6 6 0 00-12 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.546 72.348a5.9 5.9 0 118.344-8.344 5.9 5.9 0 01-8.344 8.344z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.218 68.176a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.846 81.638a3.4 3.4 0 114.808-4.808 3.4 3.4 0 01-4.808 4.808z",
    fill: "#fff",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 79.234a4 4 0 108 0 4 4 0 00-8 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.988 46.406a4.4 4.4 0 116.223-6.222 4.4 4.4 0 01-6.223 6.222z",
    fill: "#fff",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 43.295a5 5 0 1010 0 5 5 0 00-10 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.844 45.11a3.9 3.9 0 115.516-5.516 3.9 3.9 0 01-5.516 5.515z",
    fill: "#fff",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.102 42.352a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.736 73.076a5.4 5.4 0 117.637-7.636 5.4 5.4 0 01-7.637 7.636z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.555 69.258a6 6 0 1012 0 6 6 0 00-12 0z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.202 55.639h-.001c-1.422-.804-4.886-2.906-8.01-5.933-3.139-3.04-5.84-6.922-5.93-11.285h0l-.184-8.673s0 0 0 0a.7.7 0 01.45-.667h0l.479-.185c4.78-1.84 9.063-3.49 12.596-6.52a.4.4 0 01.508-.01c3.667 2.885 8.028 4.351 12.9 5.99l.452.151h0a.7.7 0 01.478.646s0 0 0 0l.184 8.672c.092 4.367-2.444 8.361-5.45 11.532-2.995 3.157-6.367 5.404-7.754 6.266h-.001a.701.701 0 01-.717.016z",
    fill: "#fff",
    stroke: "#3E21EE",
    strokeWidth: 1.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.906 56.16a1.3 1.3 0 001.33-.027c2.815-1.75 13.683-9.111 13.488-18.32l-.184-8.674a1.3 1.3 0 00-.886-1.2c-5.081-1.71-9.49-3.147-13.173-6.045a1 1 0 00-1.27.027c-3.556 3.05-7.9 4.673-12.9 6.6a1.3 1.3 0 00-.834 1.239l.184 8.674c.19 9.203 11.36 16.098 14.245 17.727z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.906 56.16a1.3 1.3 0 001.33-.027c2.815-1.75 13.683-9.111 13.488-18.32l-.184-8.674a1.3 1.3 0 00-.886-1.2c-5.081-1.71-9.49-3.147-13.173-6.045a1 1 0 00-1.27.027c-3.556 3.05-7.9 4.673-12.9 6.6a1.3 1.3 0 00-.834 1.239l.184 8.674c.19 9.203 11.36 16.098 14.245 17.727z",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.506 53.034c-3.234-1.96-11.7-7.747-11.85-14.674l-.16-7.477c4.12-1.586 8.027-3.154 11.42-5.692 3.5 2.392 7.468 3.793 11.65 5.2l.159 7.477c.146 6.931-8.074 13.07-11.22 15.166z",
    fill: "#E5E8FD",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.017 44.198a1.873 1.873 0 01-1.34-.522L37.845 40a1.876 1.876 0 01-.056-2.655 1.878 1.878 0 012.656-.056l2.479 2.376 7.483-7.806a1.878 1.878 0 112.71 2.6l-8.781 9.161a1.874 1.874 0 01-1.318.578z",
    fill: "#fff",
    stroke: "#3E21EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconConsentMgmtNoPreferenceCenter;